// Local Imports
import Logo from "assets/appLogo.svg?react";
// import SensationLogo from "assets/images/Sensation-Logo.png";
// import { Progress } from "components/ui";

// ----------------------------------------------------------------------

export function SplashScreen() {
  return (
    <div className="fixed grid h-full w-full place-content-center">
      {/* <img src={SensationLogo} className="size-28" alt="Sensation Logo" /> */}
      {/* <Progress
        color="primary"
        isIndeterminate
        animationDuration="1s"
        className="mt-2 h-1"
      /> */}
    </div>
  );
}
